export default __webpack_public_path__ + "static/media/cxeerssr.92f9e7ec.svg";